import React, { useContext, useCallback } from 'react';
import DropdownContext from './DropdownContext';
var noop = function noop() {};
/**
 * Wires up Dropdown toggle functionality, returning a set a props to attach
 * to the element that functions as the dropdown toggle (generally a button).
 *
 * @memberOf Dropdown
 */

export function useDropdownToggle() {
  var _ref = useContext(DropdownContext) || {},
    _ref$show = _ref.show,
    show = _ref$show === void 0 ? false : _ref$show,
    _ref$toggle = _ref.toggle,
    toggle = _ref$toggle === void 0 ? noop : _ref$toggle,
    setToggle = _ref.setToggle;
  var handleClick = useCallback(function (e) {
    toggle(!show, e);
  }, [show, toggle]);
  return [{
    ref: setToggle || noop,
    onClick: handleClick,
    'aria-haspopup': true,
    'aria-expanded': !!show
  }, {
    show: show,
    toggle: toggle
  }];
}
/**
 * Also exported as `<Dropdown.Toggle>` from `Dropdown`.
 *
 * @displayName DropdownToggle
 * @memberOf Dropdown
 */
function DropdownToggle(_ref2) {
  var children = _ref2.children;
  var _useDropdownToggle = useDropdownToggle(),
    props = _useDropdownToggle[0],
    meta = _useDropdownToggle[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, children(props, meta));
}
DropdownToggle.displayName = 'ReactOverlaysDropdownToggle';
/** @component */

export default DropdownToggle;